import axiosInstance from "@/helpers/axiosInstance";
import { ApiResponse } from "@/types";

const apiEndpoint = "/api/user-feed-preferences";

export interface FeedData {
    id?: string;
    name: string;
    zipcodes: string[];
    type: string[];
    price: { min: string; max: string };
    beds: { min: number; max: number };
    bath: { min: number; max: number };
}

export async function getUserFeeds(userId: string): Promise<ApiResponse<any>> {
    const response = await axiosInstance.get(`${apiEndpoint}/${userId}`);
    return response.data;
}

export async function createUserFeed(userId: string, feedData: FeedData): Promise<ApiResponse<any>> {
    const response = await axiosInstance.post(`${apiEndpoint}/${userId}`, feedData);
    return response.data;
}

export async function updateUserFeed(userId: string, feedData: FeedData & { id: string }): Promise<ApiResponse<any>> {
    const response = await axiosInstance.patch(`${apiEndpoint}/${userId}/${(feedData as any).id}`, feedData);
    return response.data;
}

export async function deleteUserFeed(userId: string, feedId: string): Promise<ApiResponse<any>> {
    const response = await axiosInstance.delete(`${apiEndpoint}/${userId}/${feedId}`);
    return response.data;
}

export const getFeedZipCodes = async (): Promise<ApiResponse<string[]>> => {
    return (await axiosInstance.get(`${apiEndpoint}/zipcodes`)).data;
};
